import { resolveClient } from './supabase';
import { getCurrentUser } from './auth';
import type { SupabaseClient } from '@supabase/supabase-js';

export interface AttachmentFile {
  name: string;
  size: number;
  mimeType: string;
  url: string;
}

export async function getAttachments(nodeId: string, client?: SupabaseClient): Promise<AttachmentFile[]> {
  const supabase = resolveClient(client);

  const user = await getCurrentUser();
  if (!user?.tenant_id) {
    throw new Error('User not authenticated or missing tenant_id');
  }

  const folderPath = `${user.tenant_id}/${nodeId}`;

  const { data: files, error: listError } = await supabase.storage.from('email-attachments').list(folderPath, {
    limit: 100,
    sortBy: { column: 'created_at', order: 'desc' },
  });

  if (listError) throw listError;
  if (!files || files.length === 0) return [];

  const attachmentsWithUrls = await Promise.all(
    files.map(async (file) => {
      const filePath = `${folderPath}/${file.name}`;
      const { data: urlData } = await supabase.storage.from('email-attachments').createSignedUrl(filePath, 3600);

      return {
        name: file.name,
        size: file.metadata?.size || 0,
        mimeType: file.metadata?.mimetype || 'application/octet-stream',
        url: urlData?.signedUrl || '',
      };
    })
  );

  return attachmentsWithUrls.filter((a) => a.url);
}
